<div class="px-3">
  
  <div class="rem-text-default mb-6">
    <div class="flex align-items-end">

      <div class="rem-bg-light px-3 py-3 mr-2">
        <i class="pi pi-tags font-medium text-xl"></i>
      </div>
      <div>
        <div class="text-2xl font-medium">Tag Management</div>
        <div class="text-right mt-2">Manage creditor tags</div>
      </div>
      
    </div>
  </div>
  
  <div class="flex justify-content-between mt-4 pr-4">
    <div class="flex align-items-center gap-3">
      <creditor-autocomplete
        (onSelect)="onSelectCreditor($event)"
      ></creditor-autocomplete>
    </div>
  
    <remitter-button   
      (click)="onOpenSideBar()" 
      label='Add New'
      icon='plus'
      severity='info'
    >     
    </remitter-button>  
  </div>
  
  <div class="mt-4 pt-2 px-3">
    <p-dataView
    #dv
    [value]="tags"
    layout="grid"
    [rows]="24"
  >
    <ng-template pTemplate="gridItem" let-tags>
  
      <div class="grid">
        <div class="col-2" *ngFor="let tag of tags">
          <div class="bg-white shadow-3 border-round p-3">
              <div [pTooltip]="tag.name" tooltipPosition="left" class="font-semibold tag-name">
                {{tag.name}}
              </div>
              <div [pTooltip]="tag.description" tooltipPosition="left" class="text-400 mt-1 text-sm tag-desc">
                {{tag.description}}
              </div>
              <div class="flex justify-content-end mt-2">
                <div class="flex align-items-center">

                  <icon-button
                    pTooltip="Edit"
                    tooltipPosition='left'
                    (click)="onOpenSideBar(tag.id, tag.name, tag.description)"
                    [icon]="'pencil'"
                    [styleClass]="'mr-1'"
                  />

                  <icon-button
                    pTooltip='Delete'
                    tooltipPosition='left'
                    (click)="onOpenDeleteModal(tag.id)"
                    [icon]="'trash'"
                  />
                  
                </div>
              </div>
          </div>
        </div>
      </div>
  
    </ng-template>
  </p-dataView>
  <p-paginator 
      (onPageChange)="onPageChange($event)" 
      [rows]="rows" 
      [totalRecords]="totalRecords" 
      [rowsPerPageOptions]="[10, 30, 50]" />
  </div>
  

</div>

  <p-sidebar [(visible)]="isSideBarVisible" styleClass="w-4" position="right">
    <div class="bg-white shadow-3 border-round p-4">
      <div class="text-xl font-medium">{{editedTagId? 'Edit ' : 'Add New '}} Tag</div>
      <input [(ngModel)]="tagName" type="text" pInputText  class="w-full mt-4" placeholder="Tag Name" />
      <textarea class="w-full mt-2" rows="5" cols="30" pInputTextarea placeholder="Tag Description" [(ngModel)]="tagDesc"></textarea>
      <div class="flex justify-content-end mt-4">
        <remitter-button
            (click)="onSave()" 
            label='Save'
            icon='send'
        >     
        </remitter-button>
      </div>
    </div>
  </p-sidebar>
  
  
<common-delete-modal 
[(visible)]="isDeleteModalVisible" 
message="Are you sure you want to delete this tag?" 
width="30vw"
(actionClicked)="onConfirmDelete()">
</common-delete-modal>

